<div class="jumbotron-fluid text-center" [@fadeInOut]>
  <h2 class="font-weight-light card-title h2">{{greetingMessage}}</h2>
  <div *ngIf="authenticated; else loggedOut">
    <p class="blue-text font-weight-bold caption">Please view your items below.</p>
    <hr class="ml-5 mr-5" />
    <button (click)="scrollTo('requests')" type="button" class="btn btn-outline-light my-2 z-depth-0"
      data-toggle="modal" data-target="#assistanceModal">REQUESTS</button>
    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
    <button (click)="scrollTo('approvals')" type="button" class="btn btn-outline-light my-2 z-depth-0"
      data-toggle="modal" data-target="#assistanceModal">APPROVALS</button>
  </div>
  <ng-template #loggedOut>
    <p class="font-weight-bold">Please login to view your Legal Ad Review items.</p>
  </ng-template>
</div>

<hr class="ml-5 mr-5" />

<div class="dashboard-content" *ngIf="authenticated && (forms || loading)" [@fadeInOut]>
  <div class="division-wrapper">
    <label for="division">Division:</label>
    <select class="form-control" name="division" #division="ngModel" [(ngModel)]="selectedDivisionId"
      (change)="setFilteredFormsList()" optionNotNeg>
      <option value="-1" selected>Select a Division To Filter By</option>
      <option *ngFor="let division of divisionData" [ngValue]="division.id">{{division.name}}</option>
    </select>
    <i class="fa fas fa-times undo" [ngClass]="{'undo-disabled': forms === forms}" (click)="undoFilters()"></i>
    <i class="fa fas fa-refresh refresh" (click)="getForms()"></i>
    <button type="button" pButton icon="pi pi-file-excel" [disabled]="!forms || !(forms.length > 0)" iconPos="left"
      label="EXPORT" (click)="exportExcel()" style="margin-right: 0.5em;" class="ui-button-success"></button>
  </div>

  <p-table class="requests" [value]="forms | filterApprovals:false | filterSubmitted:approver" [paginator]="true"
    [rows]="5" [responsive]="true">
    <ng-template pTemplate="caption">
      <span class="font-weight-light card-title h3">REQUESTS</span>
    </ng-template>
    <ng-template pTemplate="header" let-request>
      <tr>
        <th>Request ID</th>
        <th>Request Title</th>
        <th [pSortableColumn]="'dateSubmitted'">
          Date Submitted
          <p-sortIcon [field]="'dateSubmitted'" ariaLabel="Activate to sort"
            ariaLabelDesc="Activate to sort in descending order"
            ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
        </th>
        <th [pSortableColumn]="'isTimeSensitive'">
          Time Sensitive
          <p-sortIcon [field]="'isTimeSensitive'" ariaLabel="Activate to sort"
            ariaLabelDesc="Activate to sort in descending order"
            ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
        </th>
        <th>Request Status</th>
        <th>Submitted By</th>
        <th>Outside Legal</th>
        <th>Request Link</th>
      </tr>
      <tr>
        <th></th>
        <th></th>
        <th>
          <p-calendar [style]="{'width':'100%'}" [inputStyle]="{'width':'100%'}" [(ngModel)]="selectedFilterDate"
            name="selectedFilterDate" showButtonBar="true" [showTransitionOptions]="'400ms'"
            [hideTransitionOptions]="'400ms'" (onSelect)="setFilteredFormsList()"
            (onClearClick)="setFilteredFormsList()">
          </p-calendar>
        </th>
        <th></th>
        <th></th>
        <th>
          <p-multiSelect [options]="requestorItems" [(ngModel)]="selectedRequestors" defaultLabel="Requestors"
            (onChange)="setFilteredFormsList()"></p-multiSelect>
        </th>
        <th></th>
        <th></th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-request>
      <tr [ngClass]="{'time-sensitive-row': request.isTimeSensitive}">
        <td><b>{{request.legalAdId}}</b></td>
        <td>{{request.requestTitle}}</td>
        <td>{{ (request.dateSubmitted) | date:'MM/dd/yyyy' }}</td>
        <td>
          <span *ngIf="request.isTimeSensitive" class="badge badge-danger">Yes</span>
          <span *ngIf="!request.isTimeSensitive">No</span>
        </td>
        <td><b>{{request.requestStatus | formatRequestStatus}}</b></td>
        <td>{{request.requestor}}</td>
        <td>
          {{ getOutsideLegalNames(request.outsideLegals) }}
        </td>
        <td><a (click)="sendSelectedFormToRoute(request)"><button class="btn btn-outline-info btn-sm">Open
              Request</button></a></td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td class="empty-message-text" [attr.colspan]="8"> <!-- Updated colspan -->
          <span class="font-weight-light card-title h4">There are currently no forms ready for review.</span>
        </td>
      </tr>
    </ng-template>
  </p-table>

  <p-table class="approvals"
    [value]="forms | filterApprovals:true | filterCompletedApprovalsPipe:approver | sortByDateApproved"
    [paginator]="true" [rows]="5" [responsive]="true">
    <ng-template pTemplate="caption">
      <span class="font-weight-light card-title h3">APPROVALS</span>
    </ng-template>
    <ng-template pTemplate="header" let-request>
      <tr>
        <th>Request ID</th>
        <th>Request Title</th>
        <th [pSortableColumn]="'dateApproved'">
          Date Approved
          <p-sortIcon [field]="'dateApproved'" ariaLabel="Activate to sort"
            ariaLabelDesc="Activate to sort in descending order"
            ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
        </th>
        <th>Request Status</th>
        <th>Submitted By</th>
        <th>Outside Legal</th>
        <th>Approval Link</th>
      </tr>
      <tr>
        <th></th>
        <th></th>
        <th>
        </th>
        <th></th>
        <th>
          <p-multiSelect [options]="requestorItems" [(ngModel)]="selectedRequestors" defaultLabel="Requestors"
            (onChange)="setFilteredFormsList()"></p-multiSelect>
        </th>
        <th></th>
        <th></th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-approval>
      <tr>
        <td><b>{{approval.legalAdId}}</b></td>
        <td>{{approval.requestTitle}}</td>
        <td>{{ getTzDate(approval.dateApproved) }}</td>
        <td><b>{{approval.requestStatus | formatRequestStatus}}</b></td>
        <td>{{approval.requestor}}</td>
        <td>
          {{ getOutsideLegalNames(approval.outsideLegals) }}
        </td>
        <td><a (click)="sendSelectedFormToRoute(approval)"><button class="btn btn-outline-info btn-sm">Open
              Approval</button></a></td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td class="empty-message-text" [attr.colspan]="8">
          <span class="font-weight-light card-title h4">There are currently no forms that have been approved.</span>
        </td>
      </tr>
    </ng-template>
  </p-table>

  <div class="home-bottom-row">
    <button type="button" (click)="scrollTo('navbar')" class="btn btn-outline-info btn-rounded my-4 z-depth-0">Back To
      Top</button>
  </div>
</div>

<!-- For PrimeNG Toast notifications -->
<p-toast [style]="{marginTop: '80px'}"></p-toast>